<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hxfQnx/tc-custom/9781439669945.jpg?1702553743491" alt="This image is the cover for the book Lost Colony and Hatteras Island"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Colony and Hatteras Island
      </h1>
      <p class="bookDescription body article font2">
        <b>New archeological discoveries may finally solve the greatest mystery of Colonial America in this history of Roanoke and Hatteras Islands.</b><br/>  <br/> Established on what is now North Carolina’s Roanoke Island, the Roanoke Colony was intended to be England’s first permanent settlement in North America. But in 1590, the entire population disappeared without a trace. The only clue to their fate was the word “Croatoan” carved into a tree. For centuries, the legend of the Lost Colony has captivated imaginations.<br/>  <br/> Now, archaeologists from the University of Bristol, working with the Croatoan Archaeological Society, have uncovered tantalizing clues to the fate of the colony. In <i>The Lost Colony and Hatteras Island</i>, Hatteras native and amateur archaeologist Scott Dawson compiles what scholars know about the Lost Colony along with what scholars have found beneath the soil of Hatteras.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Scott Dawson
      </h2>
      
      <p class="authorDescription body article">Scott Dawson is a native of Hatteras Island whose family roots on the island trace back to the 1600s. He is a graduate of the University of Tennessee with a BA in psychology and minor in history and is a well-known local historian, local author and amateur archaeologist. He is president and founder of the Croatoan Archaeological Society Inc. and has participated in a decade of archaeological excavations and research on Hatteras Island under the direction of Dr. Mark Horton. He also serves on the board of directors of the Outer Banks History Center.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22c0ccc5